import * as React from "react";
import Spinner from "../../components/Spinner";
import { Link } from "react-router-dom";
import moment from "moment/min/moment-with-locales";
moment.locale("pl");

class EventsScreen extends React.Component {
  componentDidMount() {
    this.props.getEvents();
    document.title = "Wydarzenia"
  }

  render() {
    const { events } = this.props.events;
    if (events === null) return <Spinner />;
    else if (!events.length)
      return (
        <div className="container main-container mb-3">
          <div className="row mt-1">
            <div className="col-md-12">
              <div className="container-fluid d-flex align-items-center justify-content-center fish-info-container">
                <div className="text-center">Brak nadchodzących wydarzeń</div>
              </div>
            </div>
          </div>
        </div>
      );
    else
      return (
        <div className="container main-container mb-3 mt-3">
          <div className="row mt-1">
            <div className="col-md-12">
              <table className="table table-striped">
                <tbody>
                  {events.map((event, key) => (
                    <tr key={key}>
                      <td className="py-1">
                        <Link
                          className="no-decor text-secondary"
                          key={key}
                          to={{
                            pathname: "/event-detail",
                            event,
                          }}
                        >
                          <div className="row">
                            {event.photo && (
                              <div className="col-md-3">
                                <img
                                  className="img-fluid"
                                  alt="Zdjęcie wydarzenia"
                                  src={event.photo}
                                />
                              </div>
                            )}

                            <div className="col-md-9">
                              <p className="my-1">
                                {event.title}
                              </p>
                              <p className="m-0 small text-muted">
                                {moment(event.date.seconds * 1000).format(
                                  "DD MMMM"
                                )}
                              </p>
                              <p>
                                {event.description.length > 100
                                  ? event.description.substr(0, event.description.lastIndexOf(' ', 97)) + '...'
                                  : event.description
                                }
                              </p>
                              
                            </div>
                          </div>
                          
                          
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
  }
}

export default EventsScreen;



// WEBPACK FOOTER //
// ./src/screens/MainPage/EventsScreen.js